import { Component } from '@angular/core';
import { AlertService } from '../../../services/alert.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: true,
    imports: [
        AsyncPipe,
        NgClass
    ]
})
export class AlertComponent {

    constructor(public alertService: AlertService) {
    }

    onApprove() {
        this.alertService.onApprove();
    }

    onCancel() {
        this.alertService.onCancel();
    }
}
